export const environment = {
  production: false,
  env: 'development',
  sourceConfigFrontend: 'https://dev.source-config.dmp.emetriq.de/',
  apiSegments: 'https://api.dev.dmp.emetriq.de',
  title: 'DEV emetriq DMP',
  animation: true,
  version: '4d150ae0',
  auth: {
    ClientId: '2sjs68tcp8mfisboc4a2eia519',
    AppWebDomain: 'emq-auth.auth.eu-west-1.amazoncognito.com',
    TokenScopesArray: ['email', 'openid'],
    RedirectUriSignIn: 'https://dev.dmp.emetriq.de/signin',
    RedirectUriSignOut: 'https://dev.dmp.emetriq.de/',
    UserPoolId: 'eu-west-1_maI6P4tPq', // xsite prod :: cognito :: emq-platform-dev
    AdvancedSecurityDataCollectionFlag: true,
    // Storage: '<TODO the storage object>' // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
  }
};

export const HTTP_INTERCEPORTS = [];
